import { useState } from "react";
import { Button, Card, Flex, Form, Input, message, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  set_OrganizationID,
  set_OrgIntegratedToZoho,
} from "../features/ConfigSlice";
import { API } from "../config/auth";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const Login = () => {
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();

  const dispatch = useDispatch();

  const formItemLayout = {
    labelCol: { xs: { span: 24 }, sm: { span: 6 } },
    wrapperCol: { xs: { span: 50 }, sm: { span: 40 } },
  };

  const onSubmit = async (values) => {
    setBtnLoading(true);

    if (page === 1) {
      try {
        let response = await API.post(
          `/organization/create_organization`,
          values
        );

        if (response.data?.success === false) {
          setBtnLoading(false);

          return messageApi.error(response?.data?.message);
        }

        let organization_id = response?.data?.data?.organization_id;
        window.localStorage.setItem("organization_id", organization_id);
        dispatch(set_OrganizationID(organization_id));

        if (
          response?.data?.message ===
          "Need to collect client_id & client_secret"
        ) {
          return setPage(2);
        }

        let is_org_integrated_to_zoho = response?.data?.data?.integrated;
        window.localStorage.setItem(
          "is_org_integrated_to_zoho",
          is_org_integrated_to_zoho
        );
        dispatch(set_OrgIntegratedToZoho(is_org_integrated_to_zoho));

        window.localStorage.setItem(
          "jwt_access_token",
          response?.data?.data?.access_token
        );

        navigate("/jas");
      } catch (error) {
        console.log(error);
      } finally {
        setBtnLoading(false);
      }
    } else {
      try {
        let data = {
          organization_id: window.localStorage.getItem("organization_id"), // ✅ get correct key
          updates: { auth_type: "JAS", ...values },
          update_type: "auth_details",
        };

        let response = await API.patch(
          `/organization/update_organization`,
          data
        );

        if (response.data?.success === false) {
          setBtnLoading(false);

          return message.error(response?.data?.message);
        }

        let is_org_integrated_to_zoho = response?.data?.data?.integrated;
        window.localStorage.setItem(
          "is_org_integrated_to_zoho",
          is_org_integrated_to_zoho
        );
        dispatch(set_OrgIntegratedToZoho(is_org_integrated_to_zoho));

        navigate("/jas");
        setBtnLoading(false);
      } catch (error) {
        console.log(error);
        setBtnLoading(false);
      } finally {
        setBtnLoading(false);
      }
    }
  };

  // const generatePDF = () => {
  //   // Capture the HTML element you want to convert
  //   const input = document.getElementById("content-to-export");

  //   // Use html2canvas to render the element as an image
  //   html2canvas(input).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png"); // Convert canvas to image
  //     const pdf = new jsPDF("p", "mm", "a4"); // Create a new PDF with A4 size

  //     const imgWidth = 210; // A4 width in mm
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width; // Calculate height to maintain aspect ratio

  //     // Add the image to the PDF
  //     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
  //     pdf.save("download.pdf"); // Save the PDF
  //   });
  // };

  return (
    <>
      {contextHolder}

      <Flex
        id="content-to-export"
        align="center"
        justify="center"
        style={{ minHeight: "100dvh" }}
      >
        <Card hoverable style={{ width: "100%", maxWidth: "500px" }}>
          {page === 1 ? (
            <Form requiredMark={false} {...formItemLayout} onFinish={onSubmit}>
              <Form.Item>
                <h2 style={{ textAlign: "center" }}>Login</h2>
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    Server URL&nbsp;
                    <Tooltip
                      title={
                        <span style={{ fontSize: "12px" }}>
                          <p>Base URL of the dashboard</p>
                          <p>Eg Format: https://jasxxxxqc.my3cx.ca</p>
                        </span>
                      }
                    >
                      <HelpOutlineIcon style={{ fontSize: "16px" }} />{" "}
                    </Tooltip>
                  </span>
                }
                name="jas_server_base_url"
                required
                rules={[
                  { type: "url", message: "Please enter a valid URL!!" },
                  { required: true, message: "This field is required" },
                ]}
              >
                <Input name="jas_server_base_url" />
              </Form.Item>
              <Form.Item
                label="Email"
                name="email"
                required
                rules={[
                  { type: "email", message: "Please enter a valid email!!" },
                  { required: true, message: "This field is required" },
                ]}
              >
                <Input name="email" />
              </Form.Item>
              <Form.Item
                label="Ext number"
                name="extension_number"
                required
                rules={[{ required: true, message: "This field is required" }]}
              >
                <Input name="extension_number" />
              </Form.Item>
              <Form.Item
                label="Password"
                name="password"
                required
                rules={[{ required: true, message: "This field is required" }]}
              >
                <Input.Password name="password" />
              </Form.Item>
              <Form.Item label={null}>
                <Button type="primary" htmlType="submit" loading={btnLoading}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          ) : (
            <Form requiredMark={false} {...formItemLayout} onFinish={onSubmit}>
              <Form.Item>
                <h2 style={{ textAlign: "center" }}>Additional details</h2>
              </Form.Item>
              <Form.Item
                label="Client ID"
                name="client_id"
                required
                rules={[
                  { required: true, message: "This field is required" },
                  {
                    pattern:
                      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
                    message:
                      "Paste only the Client ID value (e.g. a3b9cacb-6411-401f-9f43-02a2bcf38cc9), without any label text",
                  },
                ]}
              >
                <Input name="client_id" placeholder="a3b9cacb-6411-401f-9f43-02a2bcf38cc9" />
              </Form.Item>
              <Form.Item
                label="Client Secret"
                name="client_secret"
                required
                rules={[
                  { required: true, message: "This field is required" },
                  {
                    pattern:
                      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
                    message:
                      "Paste only the Client Secret value (e.g. a0af0b1d-07a8-4fe3-8805-49c76289a97d), without any label text",
                  },
                ]}
              >
                <Input name="client_secret" placeholder="a0af0b1d-07a8-4fe3-8805-49c76289a97d" />
              </Form.Item>
              <Form.Item label={null}>
                <Button type="primary" htmlType="submit" loading={btnLoading}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          )}
        </Card>
      </Flex>
    </>
  );
};

export default Login;
